<template>
  <form v-if="!isDisabled && loaded" class="form-material m-t-40" :action="this.route" method="POST" :disabled="!canEdit">
    <div class="card settings-content">
      <div class="card-body payment-settings">
        <h4 class="card-title">{{ 'settings.paymentIntervals.paymentInterval' | lang }}</h4>
        <h6 class="card-subtitle">{{ 'settings.paymentIntervals.description' | lang }}</h6>
        <div class="alert alert-warning" v-if="!hasPaymentSettings">
          {{ 'settings.paymentIntervals.noPaymentSettings' | lang }} <a
            v-bind:href="this.paymentSettingsUrl+'#payment-settings'">Go to payment settings</a>
        </div>
        <div class="form-group">
          <div class="row mb-3 mb-2" v-if="canRequestPayment">
            <div class="col-6">
              <div>{{ 'settings.paymentIntervals.availableFastPayments' | lang }}</div>
              <div>
                <h3>
                  <span>
                    {{ this.availableForFastPaymentAfterRevenueShare | formatCurrency('USD', 'en-US') }}
                  </span>
                </h3>
                <div>
                  <div v-if="lastDailyEstimateDisplay" class="text-muted desc-text-small">
                    <div>Latest estimate from YouTube:</div>
                    <div>{{ this.lastDailyEstimateDisplay }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <!--            This is part of the original design from Filip, but not currently in use-->
              <!--            <div>Pending transactions</div>-->
              <!--            <div class="text-white">$</div>-->
              <!--            <div class="text-white">$availableForFastPaymentAfterRevenueShare</div>-->
            </div>
          </div>
          <div class="row mb-4" v-if="canRequestPayment">
            <div class="col-6">
              <button type="button" class="btn btn-primary get-paid mb-1"
                      @click="initiateQuickPayment"
                      :disabled="!this.quickPayEnabled">Pay me now!
              </button>
              <small>Get paid within 24 hours for a {{ this.manualFee }}% fee</small>
            </div>
            <div class="col-6">
            </div>
          </div>
          <div class="row" v-if="canSelectInterval">
            <div class="col-6">
              <button @click="selectInterval('weekly')" type="button"
                      :class="{ 'selected bg-dark': isWeeklySelected }"
                      :disabled="!this.hasPaymentSettings"
                      class="card mb-0 text-white py-3 px-4 interval-button">
                <div class="font-weight-bold mb-3">
                  {{ 'settings.paymentIntervals.weekly' | lang }}
                </div>
                <div class="small text-bold text-left mb-3">
                  {{ 'settings.paymentIntervals.weeklyDescription' | lang }}
                </div>
                <div>
                  <small>{{ this.weeklyFee }}{{ 'settings.paymentIntervals.percentFeeOnPayments' | lang }}</small>
                </div>
                <div>
                  <small>{{ this.manualFee }}{{ 'settings.paymentIntervals.percentFeeOnFastPayments' | lang }}</small>
                </div>
              </button>
            </div>
            <div class="col-6">
              <button @click="selectInterval('monthly')" type="button"
                      :class="{ 'selected bg-dark': isMonthlySelected }"
                      :disabled="!this.hasPaymentSettings"
                      class="card mb-0 text-white py-3 px-4 interval-button">
                <div class="font-weight-bold mb-3">{{ 'settings.paymentIntervals.monthly' | lang }}</div>
                <div class="small text-left mb-3">
                  {{ 'settings.paymentIntervals.monthlyDescription' | lang }}
                </div>
                <div>
                  <small>0{{ 'settings.paymentIntervals.percentFeeOnPayments' | lang }}</small></div>
                <div>
                  <small>{{ this.manualFee }}{{ 'settings.paymentIntervals.percentFeeOnFastPayments' | lang }}</small>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer" v-if="canSelectInterval && canEdit">
        <div>
          <button class="btn btn-primary" type="submit"
                  :disabled="this.selectedInterval===this.paymentInterval || !this.hasPaymentSettings">
            {{ 'settings.save' | lang }}
          </button>
          <input type="hidden" name="payment_interval" :value="this.selectedInterval"/>
          <input type="hidden" name="_token" :value="this.csrf"/>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import swal from 'sweetalert';
import axios from 'axios';


export default {
  name: "PaymentIntervalForm",
  props: {
    route: String,
  },
  data() {
    return {
      loaded: false,
      canEdit: false,
      canSelectInterval: false,
      canRequestPayment: false,
      isDisabled: true,
      quickPaymentSent: false,
      paymentInterval: null,
      selectedInterval: null,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      earlyPayableAmount: 0,
      revenueShare: null,
      weeklyFee: 5,
      manualFee: 5,
      hasPaymentSettings: false,
      lastDailyEstimateDisplay: null,
      paymentSettingsUrl: null,
    }
  },
  mounted() {
    axios.get(this.route).then((event) => {
      if (event.status !== 200) return;
      const response = event.data;
      const data = response.data;

      Object.assign(this, data);
      this.selectedInterval = this.paymentInterval || 'monthly';
      this.loaded = true;
    })
  },
  methods: {
    selectInterval(interval) {
      this.selectedInterval = interval;
    },
    submitForm() {
      this.$refs.form.$el.submit();
    },
    initiateQuickPayment() {
      let amount = this.$options.filters.formatCurrency(this.availableForFastPaymentAfterRevenueShare, 'USD', 'en-US');
      let spanElement = document.createElement("div");
      let self = this;
      spanElement.innerHTML = 'Get paid now <span class="quick-pay-amount">' + amount + "</span>";
      //TODO: LANGIFY THIS, one problem might be the button-texts which behave strangely( see https://sweetalert.js.org/docs/)
      swal({
        title: "Confirm sending money for quick pay",
        content: spanElement,
        buttons: {
          cancel: true,
          confirm: true,
        },
      }).then(function (isConfirm) {
        if (isConfirm) {
          axios.get('payableRevenues/sendQuickPayments', {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => {
            swal("Success", "Quick payment successfully sent", 'success');
            self.quickPaymentSent = true;
          }).catch(error => {
            swal(error.response.data.message, {icon: 'error'});
          });
        } else {

          swal({
            title: "Cancelled",
            text: "Your quick payment was cancelled",
            type: 'error',
            timer: 1000,
            showConfirmButton: false,
          });
        }
      });
    },
  },
  computed: {
    quickPayEnabled() {

      let userHasPaymentSettings = this.hasPaymentSettings;
      let userHasAvailableAmount = this.availableForFastPaymentAfterRevenueShare > 0;
      return userHasPaymentSettings && userHasAvailableAmount;
    },
    isWeeklySelected() {
      return this.selectedInterval === 'weekly';
    },
    isMonthlySelected() {
      return this.selectedInterval === 'monthly';
    },
    availableForFastPaymentAfterRevenueShare() {
      if (this.quickPaymentSent) {
        return 0;
      }

      return this.earlyPayableAmount * (this.revenueShare / 100)
    }
  },
}
</script>
<style scoped>
.interval-button {
  border: 2px solid rgba(255, 255, 255, 0);
  background-color: #25262d;
}

.interval-button:hover {
  background-color: #171c20
}

.selected {
  border: 2px solid #ff990d !important;
  -webkit-tap-highlight-color: unset !important;
  outline: none !important;
}

.desc-text-small {
  font-size: 10px;
}

</style>
<style>
.get-paid {
  max-width: 15rem;
}

.quick-pay-amount {
  display: block;
  margin-top: 10px;
  font-size: 1.5rem;
  font-weight: 600;
}

.swal-icon--success__hide-corners {
  background: none !important;
}

.swal-icon--success:before,
.swal-icon--success:after {
  background: none !important;
}
</style>
